<template>
  <div>
    <LoginAccountTab :activeName="activeName" />
      <List v-show="isShowList" @create="handleCreate" @edit="handleEdit" @read="handleRead" ref="list"></List>
      <Add v-if="isShowAdd" :mode="mode" :id="id" :materiaObj="materiaObj" @go-back="handleGoBack"></Add>
      <Read v-if="isShowRead" :mode="mode" :id="id" :materiaObj="materiaObj" @go-back="handleGoBack"></Read>
  </div>
</template>
<script>
import LoginAccountTab from './components/LoginAccountTab'
import List from './AdvertiserManageList'
import Add from './AdvertiserManageAdd'
import Read from './AdvertiserManageRead'
export default {
  components: {
    LoginAccountTab,
    List,
    Add,
    Read
  },
  data() {
    return {
      activeName: 'advertiserManage',
      isShowList: true,
      isShowAdd: false,
      isShowRead: false,
      id: undefined,
      mode: 'create',
      materiaObj: {}
    }
  },
  methods: {
    handleCreate() {
      this.mode = 'create'
      this.id = undefined
      this.isShowList = false
      this.isShowRead = false
      this.isShowAdd = true
    },
    handleEdit(item) {
      this.id = item.partnerId
      this.materiaObj = item
      this.mode = 'edit'
      this.isShowList = false
      this.isShowRead = false
      this.isShowAdd = true
    },
    handleRead(item) {
      this.id = item.partnerId
      this.materiaObj = item
      this.mode = 'read'
      this.isShowList = false
      this.isShowAdd = false
      this.isShowRead = true
    },
    handleGoBack(flag) {
      this.isShowAdd = false
      this.isShowRead = false
      this.isShowList = true
      this.mode = 'list'
      if (flag) {
        this.$nextTick(() => {
          this.$refs.list.fetchData()
        })
      }
    }
  },
  created() {
    if (this.$route.params.media) {
      // this.materiaObj = this.$route.params.media
      this.handleRead(this.$route.params.media)
    }
  },
  activated() {
    if (this.$route.params.add) {
      this.handleCreate()
    }
  }
}
</script>
